import React from 'react';
import { AwardIcon, GraduationCapIcon } from 'lucide-react';
import { credentials } from '../data/profile';
import { SectionHeading } from '../components/SectionHeading';
import { IndustryBackdrop } from '../components/IndustryBackdrop';
export function Credentials() {
  return <section className="relative min-h-[70vh] overflow-hidden bg-parchment pt-32 pb-24 lg:pb-32" data-id="element-148" data-mp="1dcp6bsashx04">
      <IndustryBackdrop data-id="element-149" data-mp="19b3rw2ilxant" />
      <div className="relative mx-auto max-w-[1400px] px-6 lg:px-10" data-id="element-150" data-mp="19bdle02v1zy9">
        <SectionHeading eyebrow="CREDENTIALS, EDUCATION AND CERTIFICATIONS" title="Formal grounding behind the practice" data-id="element-151" data-mp="14c0pkpu0hijj" />

        <ul className="mt-14 grid gap-6 md:grid-cols-2 xl:grid-cols-3" data-id="element-152" data-mp="zdfzhj8h4f8t">
          {credentials.map(item => {
          const isEducation = item.kind === 'Education';
          const Icon = isEducation ? GraduationCapIcon : AwardIcon;
          return <li key={item.title} className="flex flex-col border border-ink/15 bg-white p-8 transition-colors duration-150 ease-exec hover:border-gold-400" data-id="element-153" data-mp="2orcgoardq1h3">
                <span className="flex items-center gap-3 text-sm tracking-wider2 text-grass-600" data-id="element-154" data-mp="3mkclhsmfdasn">
                  <Icon className="h-5 w-5 text-gold-500" data-id="element-155" data-mp="37nlk5dt6xp0e" />
                  {item.kind.toUpperCase()}
                </span>
                <h3 className="mt-5 text-xl leading-snug text-ink" data-id="element-156" data-mp="3cmeyt9k7rm25">{item.title}</h3>
                <p className="mt-3 text-lg text-slate-700" data-id="element-157" data-mp="474qhjpqdklx">{item.issuer}</p>
                <p className="mt-auto pt-6 text-base text-slate-500" data-id="element-158" data-mp="95pqpj4zg4ad">{item.detail}</p>
              </li>;
        })}
        </ul>
      </div>
    </section>;
}